import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  clientIDs: 'clientIDs',
  CylinderType: 'CylinderType',
  CylinderClass: 'CylinderClass',
  CylinderStatus: 'CylinderStatus',
  Location: 'Location',
  SearchText: 'SearchText',
  OrderNumber: 'OrderNumber',
  RentalAgreementNumber: 'RentalAgreementNumber',
  CylinderSubStatus: 'CylinderSubStatus',
  Requestor: 'Requestor',
  reportAddressIDs: 'reportAddressIDs',
  DaysOut: 'DaysOut',
  ShippingDateFrom: 'ShippingDateFrom',
  ShippingDateTo: 'ShippingDateTo',
  functionality: 'functionality',
  scenarioIDs: 'scenarioIDs',
  ReturnDueDateFrom: 'ReturnDueDateFrom',
  ReturnDueDateTo: 'ReturnDueDateTo',
};

const initialFilterState = {
  clientIDs: [],
  CylinderType: null,
  CylinderClass: null,
  CylinderStatus: null,
  Location: null,
  SearchText: '',
  OrderNumber: '',
  RentalAgreementNumber: '',
  CylinderSubStatus: null,
  Requestor: '',
  reportAddressIDs: [],
  DaysOut: null,
  ShippingDateFrom: null,
  ShippingDateTo: null,
  functionality: 'Cylinder',
  ReturnDueDateFrom: null,
  ReturnDueDateTo: null,
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'ClientName',
  sortDirection: SortDirection.Desc,
};

export const sliceName = 'cylinderSearch';
const cylinderSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const cylinderSearchActions = cylinderSearchSlice.actions;
export default cylinderSearchSlice.reducer;
